import React from "react";
import { Box, Button, Link, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useDispatchWrapper } from "../../../../../../hooks";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { IBusinessPolicyLiability } from "../../../../../../redux/businessPolicy/businessPolicyLiability/businessPolicyLiability.types";
import {
  downloadBusinessLiabilityListPDFAsync,
  fetchBusinessLiabilityListAsync,
  previewBusinessLiabilityListPDFAsync,
} from "../../../../../../redux/businessPolicy/businessPolicyLiability/businessPolicyLiabilityActions";
import { CustomSelect } from "../../../../../../components/formsComponents";
import { renderDropdownValue } from "../../../../../../helpers";
import { NotificationsActive, ThumbUpAlt } from "@mui/icons-material";
import { CustomChip } from "../../../../../../components/CustomChip";

export const CSIOCertificateList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();

  const {
    businessPolicyLiabilityList: data,
    businessPolicyLiabilityListLoading: loading,
  } = useSelector((storeState: IStoreState) => storeState.business.lability);

  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useDispatchWrapper();

  const [selectedCsio, setselectedCsio] = React.useState<{
    isAllSelected: boolean;
    certificate: IBusinessPolicyLiability[];
  }>({
    isAllSelected: false,
    certificate: [],
  });

  const menuItems =
    selectedCsio.certificate.length > 0 || selectedCsio.isAllSelected
      ? [
          {
            key: "action",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={""}
                displayEmpty
                renderValue={renderDropdownValue(`Choose bulk Action`)}
                //onChange={(e) => setBranchOffice(e.target.value as string)}
              >
                <MenuItem value="1">Email</MenuItem>
              </CustomSelect>
            ),
          },
        ]
      : [];

  const LiabilityTableProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    selectionMode: "multiple",
    uniqueRowKeyName: "incremental_number",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [...menuItems],
      },
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}/liability`
                  );
                }}
              >
                Create
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: IBusinessPolicyLiability) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}/liability/${row.incremental_number}`
                )
              }
            >
              {row.incremental_number}
            </Link>
          );
        },
      },

      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IBusinessPolicyLiability) => {
          if (row.status === "ACTIVE") {
            return (
              <CustomChip
                color="success"
                icon={<ThumbUpAlt />}
                content={"Active"}
                size="small"
              />
            );
          } else {
            return (
              <CustomChip
                color="error"
                icon={<NotificationsActive />}
                content={"Cancel"}
                size="small"
              />
            );
          }
        },
      },
      {
        key: "automobile_policy",
        headerName: "Automobile Policy",
        fieldName: "automobile_policy",
        renderType: RenderType.TEXT_DARK,
        exportCellWidth: 30,
      },

      {
        key: "certificate_holder_name",
        headerName: "Certificate Holder Name",
        fieldName: "certificate_holder_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "hired_automobiles",
        headerName: "Hired Automobiles",
        fieldName: "hired_automobiles",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "certificate_holder_email",
        headerName: "Certificate Holder Email",
        fieldName: "certificate_holder_email",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IBusinessPolicyLiability) => {
          return (
            <StandardTableActions
              downloadLoading={downloading}
              onDownloadPreview={() => {
                dispatch(
                  previewBusinessLiabilityListPDFAsync(
                    customerPolicyId,
                    row.incremental_number as number,
                    () => {}
                  )
                );
              }}
              onDownLoadClick={() => {
                if (row.incremental_number) {
                  setDownloading(true);
                  dispatch(
                    downloadBusinessLiabilityListPDFAsync(
                      customerPolicyId,
                      row.incremental_number,
                      () => {
                        setDownloading(false);
                      }
                    )
                  );
                }
              }}
              onEditClick={() => {
                navigate(
                  `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}/liability/${row.incremental_number}`
                );
              }}
              onDuplicateClick={() => {
                navigate(
                  `/business-policy/${customerId}/policy-forms-tab/${customerPolicyId}/liability-duplicate/${row.incremental_number}`
                );
              }}
            />
          );
        },
      },
    ],
    items: data,
    onSelection: (isAllSelected: boolean, rows: IBusinessPolicyLiability[]) => {
      setselectedCsio({ isAllSelected: isAllSelected, certificate: rows });
    },
  };

  React.useEffect(() => {
    dispatch(fetchBusinessLiabilityListAsync(customerPolicyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPolicyId]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...LiabilityTableProps} />
      </Box>
    </>
  );
};
